import Vue from 'vue'
import { v4 as uuid } from 'uuid'

import authentication from './authentication'
import requests from './requests'
import trade from './trade'
import validations from './validations'
import portfolio from './portfolio'
import router from '../router'

const VueRouter = router.history.router

Vue.mixin({
	computed: {
		today() {
			return new Date().toJSON().slice(0, 10)
		},
		yesterday() {
			const date = new Date();
			date.setDate(date.getDate() - 1)

			return date.toJSON().slice(0, 10)
		},
		isMobile() {
			return window.innerWidth <= 768
		},
		isPrincipalAccount() {
			const { user, activeAccount } = this.$store.getters

			if (user.type === 'customer') {
				return user.customer.external_client_id === activeAccount.external_client_id
			}

			return false
		},
		isNewUser() {
			const user = this.$store.getters.user

			return user ? user.first_time_login : false
		}
	},
	methods: {
		goBack: (where = 'history') => {
			if (where === 'parent') {
				let parent = VueRouter.history.current.matched[0].path.substr(1)

				router.push({
					name: parent,
				})
			} else {
				router.go(-1)
			}
		},
		hideAlert() {
			$('.alert')
				.fadeTo(500, 0)
				.slideUp(500, function() {
					$(this).remove()
				})
		},
		hasChildActive: route => {
			const paths = Array.isArray(route) ? route : [route]

			return paths.some(path => {
				return VueRouter.currentRoute.path.indexOf(path) === 0
			})
		},
		generateId(length = 8) {
			const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
			let str = ''

			for (let i = 0; i < length; i++) {
				str += chars.charAt(Math.floor(Math.random() * chars.length))
			}

			return str
		},
		respectSnakeCase(object) {
			return _.transform(object, (newObject, value, key, target) => {
				const snakeCasedKey = _.isArray(target) ? key : _.snakeCase(key)

				newObject[snakeCasedKey] = _.isObject(value) ? this.respectSnakeCase(value) : value
			})
		},
		generateProcessingNumber() {
			return uuid().replace(/-/g, '')
		},
		groupBy(data, iteratee) {
			return _.groupBy(data, iteratee);
		},
		isEmpty(value) {
			return _.isEmpty(value)
		},
		isNull(value) {
			return _.isNull(value)
		},
		sanitizeSourceOfFunds(sourceOfFunds) {
			let source = sourceOfFunds || []

			try {
				source = typeof JSON.parse(sourceOfFunds) === 'number' ? sourceOfFunds : JSON.parse(sourceOfFunds)
			} catch (error) {}

			return source
		},
		can(action = null) {
			if (action) {
				const { user } = this.$store.getters

				if (user.type === 'back-office') {
					return user.back_office.permissions.some((permission) => permission.name === action)
				}
			}

			return false
		},
	},
})

export { authentication, trade, validations, requests, portfolio }
